import { Civility } from './civility.enum';

type civilities_label = "M" | "Mme";

export const CIVILITIES_OPTIONS: { label: civilities_label, value: Civility }[] = [
  { label: 'M', value: Civility.MALE },
  { label: 'Mme', value: Civility.FEMALE },
];

export const get_civility_label = (civility: Civility): civilities_label => {
  return civility === Civility.MALE ? 'M' : 'Mme';
}
